import type {Fond, RecordEditation} from 'src/typings';
import type {PromiseBasedRecordEditationDataService, RecordEditationAction} from '../types';
import type {Observable} from 'rxjs';
import {GenericEditationAction} from './generic-editation-action';
import {from} from 'rxjs';

export class SetFondAction extends GenericEditationAction implements RecordEditationAction {
    constructor(private backend: PromiseBasedRecordEditationDataService, private fond: Fond) {
        super('SetFondAction');
    }

    public executeAction(editationObject: RecordEditation): Observable<RecordEditation> {
        return from(this.backend.setFond(editationObject.id, this.fond.id));
    }
}